// Drop-down panels for top-level nav items. See sections/abc-community-menu.liquid.
//
// Sets up once PER PANEL. The section is used twice (artbeat community, workshops) and
// a section's script is loaded once per TYPE, not per instance, so a single
// querySelector would wire the first panel and silently ignore the second.
(function () {
  if (window.__abcNavPanelReady) return;   // two instances, two script tags, one run
  window.__abcNavPanelReady = true;

  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  // The panel's CSS hides it at max-width 1000px. A mouse on a narrow window is still
  // a fine pointer, so without this a click on the drawer's copy of the tab would be
  // swallowed to open a panel that cannot show.
  const wide = window.matchMedia('(min-width: 1001px)');

  // The phone drawer, a second copy of the nav that the theme draws itself.
  function drawerList() {
    return document.querySelector('.header-section .menu-drawer__navigation > ul.menu-drawer__menu');
  }

  function drawerItem(list, wanted) {
    if (!list || !wanted) return null;
    return Array.prototype.slice.call(list.children).find(function (li) {
      const a = li.querySelector(':scope > a[href]');
      return a && (a.getAttribute('href') || '').replace(/\/$/, '').endsWith(wanted);
    }) || null;
  }

  function header() {
    return document.querySelector('.header-section') || document.querySelector('header');
  }

  // The transparent home header is absolutely positioned, so .header-section collapses
  // and reports a bottom ABOVE the nav row. Measure the header element itself too.
  function headerBottom() {
    const root = header();
    if (!root) return 0;
    let b = root.getBoundingClientRect().bottom;
    root.querySelectorAll('header-component, .header').forEach(function (el) {
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > b) b = r.bottom;
    });
    return b;
  }

  function setup(panel, index) {
    const wanted = (panel.dataset.abcTriggerHref || '').replace(/\/$/, '');
    const label = (panel.dataset.abcTriggerLabel || '').trim();
    const extraLabel = (panel.dataset.abcExtraLabel || '').trim();
    const extraUrl = (panel.dataset.abcExtraUrl || '').trim();
    const overviewLabel = (panel.dataset.abcOverviewLabel || '').trim();
    const mark = 'abcNavPanel' + index;        // data-abc-nav-panel<N>
    const sel = '[data-abc-nav-panel' + index + ']';
    let closeTimer = null;

    // Matched by href suffix first and visible label second, so renaming the item in
    // the Shopify menu does not break the panel and a /hr prefix still matches. Only
    // laid-out instances count, and nothing inside the phone drawer: an OPEN drawer is
    // laid out too, and its links (the "about" line in an accordion list included)
    // were then taken for the desktop tab - addTab cloned workshops into the
    // community list. The drawer has its own functions below.
    function triggers() {
      const root = header();
      if (!root) return [];
      return Array.prototype.slice.call(root.querySelectorAll('a[href]')).filter(function (a) {
        if (a.closest('header-drawer, .menu-drawer')) return false;
        const href = (a.getAttribute('href') || '').replace(/\/$/, '');
        const text = (a.textContent || '').trim().toLowerCase();
        if (!(wanted && href.endsWith(wanted)) && text !== label) return false;
        const r = a.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });
    }

    function setExpanded(state) {
      triggers().forEach(function (a) { a.setAttribute('aria-expanded', String(state)); });
    }

    // Never sit higher than just under the trigger: on the home page the panel would
    // otherwise open on top of the very link that opens it and break hover tracking.
    function place() {
      let top = headerBottom();
      const first = triggers()[0];
      if (first) top = Math.max(top, first.getBoundingClientRect().bottom + 6);
      panel.style.setProperty('--abc-navpanel-top', Math.max(0, Math.round(top)) + 'px');
    }

    function open() {
      if (!fine.matches || !wide.matches) return;
      clearTimeout(closeTimer);
      place();
      panel.setAttribute('data-open', '');
      setExpanded(true);
    }

    function close(delay) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        panel.removeAttribute('data-open');
        setExpanded(false);
      }, delay || 0);
    }

    // The extra tab is a clone of this panel's own nav item, so it inherits the
    // theme's nav styling instead of guessing at it.
    function addTab() {
      if (!extraLabel || !extraUrl) return;
      const first = triggers()[0];
      if (!first) return;
      const item = first.closest('li') || first;
      const parent = item.parentElement;
      if (!parent || parent.querySelector('[data-abc-extra-tab]')) return;
      const clone = item.cloneNode(true);
      clone.setAttribute('data-abc-extra-tab', '');
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      clone.querySelectorAll('ul, details, [data-submenu]').forEach(function (n) { n.remove(); });
      const link = clone.matches('a') ? clone : clone.querySelector('a');
      if (!link) return;
      link.setAttribute('href', extraUrl);
      // The clone inherits this panel's wiring; it belongs to the other panel.
      link.removeAttribute('data-abc-nav-panel' + index);
      link.removeAttribute('aria-haspopup');
      link.removeAttribute('aria-expanded');
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let node, replaced = false;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue.trim()) continue;
        node.nodeValue = replaced ? '' : extraLabel;
        replaced = true;
      }
      item.after(clone);
      // <overflow-list> measured before this tab existed, so make it recount.
      window.dispatchEvent(new Event('resize'));
    }

    function bind() {
      triggers().forEach(function (a) {
        if (a.dataset[mark]) return;
        a.dataset[mark] = '1';
        a.setAttribute('aria-haspopup', 'true');
        a.setAttribute('aria-expanded', 'false');
        a.addEventListener('mouseenter', open);
        a.addEventListener('mouseleave', function () { close(140); });
        a.addEventListener('focus', open);
        a.addEventListener('click', function (event) {
          // Desktop: the tab only opens the panel. Touch and narrow windows keep the
          // link, because the panel is hidden under 1000px and a tap would otherwise
          // do nothing.
          if (!fine.matches || !wide.matches) return;
          event.preventDefault();
          open();
        });
      });
      addTab();
      addDrawerTab();
      addDrawerChildren();
    }

    // PHONES. The panel is hidden under 1000px, so on a phone the drawer showed these
    // items as bare links and nothing under them. The panel's own tiles are copied
    // under the item as the theme's child list - the markup "artworks" gets - so the
    // two menus cannot drift apart. A tile with no link stays plain text marked
    // "coming soon", as it is in the panel.
    //
    // The extra tab is added to the drawer here as well rather than left to addTab,
    // which only sees laid-out links and so only reached the drawer while it was open.
    // Same data-abc-extra-tab mark, so whichever runs first, the other stands down.
    function addDrawerTab() {
      if (!extraLabel || !extraUrl) return;
      const list = drawerList();
      const item = drawerItem(list, wanted);
      if (!item || list.querySelector(':scope > [data-abc-extra-tab]')) return;
      const clone = item.cloneNode(true);
      clone.setAttribute('data-abc-extra-tab', '');
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      clone.querySelectorAll('ul, details, [data-submenu], [data-abc-drawer-list]').forEach(function (n) { n.remove(); });
      const link = clone.querySelector(':scope > a');
      if (!link) return;
      link.hidden = false;
      link.style.removeProperty('display');
      link.setAttribute('href', extraUrl);
      Array.prototype.slice.call(link.attributes).forEach(function (attr) {
        if (/^data-abc-nav-panel|^aria-(haspopup|expanded|current)$/.test(attr.name)) link.removeAttribute(attr.name);
      });
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let node, replaced = false;
      while ((node = walker.nextNode())) {
        if (!node.nodeValue.trim()) continue;
        node.nodeValue = replaced ? '' : extraLabel;
        replaced = true;
      }
      item.after(clone);
    }

    // TWO DRAWER STYLES, following the header's "accordion" setting. Flat: every list is
    // open and the item's own name stays a link. Accordion: the name becomes a button
    // that opens the list, built by cloning one of the theme's own accordions so the
    // markup, plus icon and animation are the theme's. The item's link is kept but
    // hidden, because the scripts find this item by that href. A button cannot be a
    // link too, so - as the theme does with "All artists" - the item's own page is
    // listed first unless a tile already points at it.
    function addDrawerChildren() {
      const list = drawerList();
      const item = drawerItem(list, wanted);
      if (!item || item.querySelector(':scope > [data-abc-drawer-list]')) return;
      const link = item.querySelector(':scope > a[href]');
      const entries = [];
      // Group headings ("Booking open") travel with the first tile after them, and a
      // highlighted tile keeps its date label, so the phone menu tells the bookable
      // workshop from the "coming soon" ones just as the panel does.
      let group = '';
      panel.querySelectorAll('.abc-navtile, .abc-navpanel-group').forEach(function (el) {
        if (el.classList.contains('abc-navpanel-group')) {
          group = el.textContent.trim();
          return;
        }
        const titleEl = el.querySelector('.abc-navtile-title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        const dateEl = el.querySelector('.abc-navtile-date');
        if (title) entries.push({ title: title, href: el.matches('a') ? el.getAttribute('href') : '', group: group, date: dateEl ? dateEl.textContent.trim() : '' });
        group = '';
      });
      if (!entries.length || !link) return;

      const template = item.classList.contains('menu-drawer__list-item--deep') &&
        list.querySelector(':scope > li > accordion-custom:not([data-abc-drawer-list])');
      if (template) {
        const own = entries.some(function (e) {
          return e.href && e.href.split('#')[0].replace(/\/$/, '').endsWith(wanted);
        });
        if (!own) entries.unshift({ title: overviewLabel || link.textContent.trim(), href: link.getAttribute('href') });
      }

      const soon = /^hr/i.test(document.documentElement.lang || '') ? 'uskoro' : 'coming soon';
      const index = item.style.getPropertyValue('--menu-drawer-animation-index') || '1';
      function fill(ul, accordion) {
        let n = 0;
        function heading(textValue) {
          const li = document.createElement('li');
          li.className = 'menu-drawer__list-item';
          li.style.setProperty('--menu-drawer-animation-index', accordion ? String(++n) : index);
          const label = document.createElement('span');
          label.className = 'menu-drawer__menu-item menu-drawer__menu-item--child' + (accordion ? '' : ' menu-drawer__animated-element');
          label.style.cssText = 'font-size:12px;opacity:.55;text-transform:lowercase;padding-top:14px;';
          label.textContent = textValue;
          li.appendChild(label);
          ul.appendChild(li);
        }
        entries.forEach(function (e) {
          if (e.group) heading(e.group);
          const li = document.createElement('li');
          li.className = 'menu-drawer__list-item';
          li.style.setProperty('--menu-drawer-animation-index', accordion ? String(++n) : index);
          const entry = document.createElement(e.href ? 'a' : 'span');
          entry.className = 'menu-drawer__menu-item menu-drawer__menu-item--child' +
            (accordion ? '' : ' menu-drawer__animated-element') + (e.href ? ' focus-inset' : '');
          if (e.href) {
            entry.setAttribute('href', e.href);
          } else {
            entry.setAttribute('aria-disabled', 'true');
            entry.style.opacity = '.45';
          }
          const text = document.createElement('span');
          text.className = 'menu-drawer__menu-item-text wrap-text';
          text.style.textTransform = 'lowercase';   // as the panel's titles, both languages
          text.textContent = e.href ? e.title : e.title + ' \u00b7 ' + soon;
          entry.appendChild(text);
          if (e.date) {
            const date = document.createElement('span');
            date.textContent = e.date;
            date.style.cssText = 'flex:none;align-self:center;margin-left:10px;font-size:13px;white-space:nowrap;';
            entry.appendChild(date);
          }
          li.appendChild(entry);
          ul.appendChild(li);
        });
      }

      if (template) {
        const acc = template.cloneNode(true);
        acc.setAttribute('data-abc-drawer-list', '');
        ['open', 'open-by-default-on-mobile', 'open-by-default-on-desktop'].forEach(function (a) { acc.removeAttribute(a); });
        acc.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        const details = acc.querySelector('details');
        const label = acc.querySelector('summary .menu-drawer__menu-item-text');
        const ul = acc.querySelector('details > ul');
        if (!details || !label || !ul) return;
        details.removeAttribute('open');
        label.textContent = link.textContent.trim();
        ul.replaceChildren();
        fill(ul, true);
        // The attribute alone loses to the theme's display:flex on menu items.
        link.hidden = true;
        link.style.display = 'none';
        item.appendChild(acc);
        return;
      }

      const ul = document.createElement('ul');
      ul.className = 'menu-drawer__menu menu-drawer__menu--childlist';
      ul.setAttribute('role', 'list');
      ul.setAttribute('tabindex', '-1');
      ul.setAttribute('data-abc-drawer-list', '');
      fill(ul, false);
      item.appendChild(ul);
    }

    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { close(0); });
    panel.addEventListener('focusout', function (event) {
      if (!panel.contains(event.relatedTarget)) close(0);
    });

    // Backstop. A panel that appears under a stationary cursor never gets its own
    // mouseenter, so its mouseleave never fires either and it would stay open. The
    // check is against THIS panel's triggers, so hovering the other panel's tab
    // closes this one.
    document.addEventListener('pointerover', function (event) {
      if (!panel.hasAttribute('data-open')) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (panel.contains(target)) return;
      if (target.closest(sel)) return;
      close(120);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close(0);
    });
    window.addEventListener('scroll', function () {
      if (panel.hasAttribute('data-open')) place();
    }, { passive: true });
    window.addEventListener('resize', function () { bind(); place(); });

    bind();
    new MutationObserver(bind).observe(header() || document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-abc-navpanel]').forEach(setup);
})();
